import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Lottie from 'lottie-react';
import SignImg from '../assets/sign.json';
import { useNavigate, useLocation } from 'react-router-dom';
import useFormStore from "../state/useFormStore";
import ValidacionExitosa from '../components/ValidacionExitosa';
import withAuthAndData from '../components/withAuthAndData';

const Wrapper = styled.div`
  height: 100vh;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin: 0 36px;
  padding-bottom: 100px;
`;

const MainText = styled.div`
  margin: 30px 0 20px 0;
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.basic2000};
  text-align: center;
`;

const Subtext = styled.h4`
  font-size: 18px;
  line-height: 26px;
  font-weight: 400;
  margin: 0 0 20px 0;
  text-align: center;
  width: 80%;
  color: ${({ theme }) => theme.colors.basic1000};

  @media (orientation: portrait) and (max-width: 767px) {
    width: 100%;
  }
`;

const OptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: 100%;
  max-width: 400px;
`;

const ValidacionBiometria = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isDifferentDevice, setIsDifferentDevice] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const hashFromUrl = location.pathname.split('/')[1];
  const hash = hashFromUrl;

  useEffect(() => {
    const checkDevice = () => {
      try {
        const storedData = localStorage.getItem(`prestix_${hash}`);
        if (storedData) {
          const data = JSON.parse(storedData);
          const deviceId = data.deviceId;
          const currentDeviceId = localStorage.getItem('deviceId');

          if (deviceId && currentDeviceId && deviceId !== currentDeviceId) {
            setIsDifferentDevice(true);
          }
        }else{
          setIsDifferentDevice(true);
        }
      } catch (error) {
        console.error('Error al verificar dispositivo:', error);
      } finally {
        setIsLoading(false);
      }
    };

    checkDevice();
  }, [hash]);

  if (isLoading) {
    return (
      <Wrapper>
        <MainText>Cargando...</MainText>
      </Wrapper>
    );
  }

  if (isDifferentDevice) {
    return (
      <Wrapper>
        <MainText>Dispositivo diferente detectado</MainText>
        <Subtext>
          Para continuar con tu solicitud, por favor vuelve al dispositivo donde comenzaste el proceso.
          <br />
          <br />
          Si necesitas ayuda, contáctanos.
        </Subtext>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <ValidacionExitosa />
    </Wrapper>
  );
};

export default withAuthAndData(ValidacionBiometria);